import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";

/*
 * @Author: your name
 * @Date: 2021-08-17 09:34:45
 * @LastEditTime: 2021-08-17 09:55:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \IMS.Vue.D2_UT\src\views\mixin\SeniorMixin.js
 */
export default function (_ref) {
  var _ref$SeniorVariable = _ref.SeniorVariable,
      SeniorVariable = _ref$SeniorVariable === void 0 ? 'formData' : _ref$SeniorVariable;
  return {
    data: function data() {
      return {
        SeniorDrawer: false // 高级查询

      };
    },
    methods: {
      // 回车
      SeniorEnter: function SeniorEnter(data) {
        var _this = this;

        Object.keys(data).map(function (keys) {
          _this[SeniorVariable][keys] = data[keys];
        });
        this.SeniorClose(false);
        this.searchClick();
      },
      // 重置
      SeniorReset: function SeniorReset(data) {
        var _this2 = this;

        Object.keys(data).map(function (keys) {
          delete _this2[SeniorVariable][keys];
        });
        this.SeniorClose(false);
        this.searchClick();
      },
      // 关闭
      SeniorClose: function SeniorClose(flag) {
        this.SeniorDrawer = false;
      }
    }
  };
}